import { useEntityActionAllowed } from "@/hooks/use-entity-action-allowed";
import type { AttachmentRequirementEntityKind } from "./required-attachments-field";

const typeAttachmentRequirementActions = {
	job: {
		name: "EditJobTypeAttachmentRequirement",
		entityType: "JobType",
	},
	ticket: {
		name: "EditTicketTypeAttachmentRequirement",
		entityType: "TicketType",
	},
	asset: {
		name: "EditAssetTypeAttachmentRequirement",
		entityType: "AssetType",
	},
	record: {
		name: "EditRecordTypeAttachmentRequirement",
		entityType: "RecordType",
	},
} as const satisfies Record<
	AttachmentRequirementEntityKind,
	{ name: string; entityType: string }
>;

export function typeAttachmentRequirementAction(
	kind: AttachmentRequirementEntityKind,
) {
	return typeAttachmentRequirementActions[kind];
}

/** Pending, error, and false all leave the attachment-requirement control closed. */
export function useCanEditTypeAttachmentRequirement(
	kind: AttachmentRequirementEntityKind,
	typeId: string,
) {
	return useEntityActionAllowed({
		...typeAttachmentRequirementAction(kind),
		entityId: typeId,
		enabled: typeId.length > 0,
	});
}
